import React from 'react';

const AuthCard = ({ children, title, subtitle }) => {
  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-card rounded-2xl shadow-2xl border border-border overflow-hidden">
        <div className="p-8 md:p-10 lg:p-12">
          <div className="flex flex-col items-center mb-8">
            <div className="mb-4">
              <img
                src="/assets/images/image-1772733559968.png"
                alt="SocialCents logo"
                className="h-16 md:h-20 w-auto object-contain"
              />
            </div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground text-center mb-2">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm md:text-base text-muted-foreground text-center">
                {subtitle}
              </p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthCard;